export * from './dance-studio-overview-ad.component';
export * from './dance-studio-overview-ad.module';
